import { taxesUrl } from './resources.js'
import common from './common.js'
import store from '../store/index.js'
//
//Always get current restaurant from the store
//
async function getTaxesByRestaurant() {
    let restaurantid = store.state.restaurants.currentRestaurant.restaurantId;
    let url = `${taxesUrl}/getbyrestaurant/${restaurantid}`;
    let data;
    await common.getDataWithToken(url)
                .then(response => {
                    data = response.taxes });
    return data;
}



async function createTax(data) {
    let url = `${taxesUrl}`;
    data.restaurantId = store.state.restaurants.currentRestaurant.restaurantId;
    return await common.postData(url, data)
                .catch(err => console.log(err));
}

async function updateTax(data) {
    let url = `${taxesUrl}/${data.taxId}`;
    data.restaurantId = store.state.restaurants.currentRestaurant.restaurantId;
    await common.putData(url, data);
}

async function deleteTax(categoryId) {
    let url = `${taxesUrl}/${categoryId}`;
    await common.deleteData(url);
}

export default {
    name: 'taxesService',
    getTaxesByRestaurant,
    createTax,
    updateTax,
    deleteTax
}